import { DOCUMENT_VIEW_REQUEST, DOCUMENT_VIEW_SUCCESS, DOCUMENT_VIEW_FAILURE } from './view';
import { SIGN_REQUEST, SIGN_FAILURE, SIGN_SUCCESS } from './sign';

export function fetchDocument(id: number) {
    return (dispatch) => {
        dispatch({ type: DOCUMENT_VIEW_REQUEST });
        return fetch(`/api/pub/documents/${id}`)
            .then(async (response) => {
                const data = response.ok ? await response.json() : {};
                if (data.status === 'success') {
                    dispatch({
                        type: DOCUMENT_VIEW_SUCCESS,
                        payload: data.result
                    });
                } else {
                    dispatch({ type: DOCUMENT_VIEW_FAILURE });
                }
            });
    }
}

export function signDocs(docs: Array<string>, key: Key) {
  return (dispatch) => {
    dispatch({ type: SIGN_REQUEST });
    return fetch("/api/pub/sign", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ docs, key }),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: SIGN_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: SIGN_FAILURE,
          payload: data,
        });
      }
    });
  };
}